'use client';

import { create } from 'zustand';

export type AppLaunchPhase = 'idle' | 'launching' | 'launched';

interface AppLaunchStore {
  phase: AppLaunchPhase;
  relaunchUrl: string | null;
  startLaunch: (relaunchUrl: string) => void;
  markLaunched: () => void;
  settleLaunch: () => void;
}

export const useAppLaunchStore = create<AppLaunchStore>((set, get) => ({
  phase: 'idle',
  relaunchUrl: null,
  startLaunch: (relaunchUrl) => set({ phase: 'launching', relaunchUrl }),
  markLaunched: () => set({ phase: 'launched' }),
  //* 타임아웃이 hidden 뒤에 늦게 터져도 이미 launched면 idle로 되돌리지 않는다
  settleLaunch: () => {
    if (get().phase === 'launching') {
      set({ phase: 'idle' });
    }
  },
}));

//* 어느 파트너인지는 담지 않는다(그건 modules/partner의 레지스트리). 훅을 못 쓰는 곳도 같은 진실을
//* 봐야 하고, 같은 커밋의 쓰기를 보려면 구독이 아니라 getState여야 한다
export const isAppLaunching = () =>
  useAppLaunchStore.getState().phase === 'launching';

export const isAppLaunchSettled = () =>
  useAppLaunchStore.getState().phase === 'idle';

export const isAppLaunched = () =>
  useAppLaunchStore.getState().phase === 'launched';
